import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { useApp } from "../context/AppContext";
import { formatPrice } from "../i18n/translations";

const CartPage = () => {
  const { t, cart, products, currency, updateQty, removeFromCart, cartSubtotal } = useApp();
  const nav = useNavigate();

  return (
    <main className="py-20 min-h-[60vh]" data-testid="cart-page">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <h1 className="font-display text-4xl lg:text-5xl mb-12 text-center">{t.cart.title}</h1>
        {cart.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[var(--grey)] mb-6">{t.cart.empty}</p>
            <Link to="/shop" className="link-lux text-xs tracking-[0.25em] uppercase">{t.cart.continueShopping}</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 divide-y divide-[var(--champagne)]/60 border-y border-[var(--champagne)]/60">
              {cart.map((item) => {
                const p = products.find((p) => p.id === item.product_id);
                if (!p) return null;
                return (
                  <div key={item.product_id} className="flex gap-6 py-6">
                    <img src={p.images[0]} alt={p.name} className="w-24 h-28 object-cover bg-[var(--ivory-deep)]" />
                    <div className="flex-1">
                      <Link to={`/product/${p.slug}`} className="font-serif text-xl link-lux">{p.name}</Link>
                      <div className="text-sm text-[var(--grey)] mt-1">{formatPrice(p.price, currency)}</div>
                      <div className="flex items-center gap-4 mt-4">
                        <div className="flex items-center border border-[var(--champagne-deep)]">
                          <button className="px-2 py-1" onClick={() => updateQty(item.product_id, item.quantity - 1)}><Minus className="w-3 h-3" /></button>
                          <span className="px-3 text-sm">{item.quantity}</span>
                          <button className="px-2 py-1" onClick={() => updateQty(item.product_id, item.quantity + 1)}><Plus className="w-3 h-3" /></button>
                        </div>
                        <button onClick={() => removeFromCart(item.product_id)} className="text-[10px] tracking-[0.2em] uppercase text-[var(--grey)] hover:text-[var(--noir)]">
                          <X className="w-3 h-3 inline mr-1" />{t.cart.remove}
                        </button>
                      </div>
                    </div>
                    <div className="font-serif text-lg">{formatPrice(p.price * item.quantity, currency)}</div>
                  </div>
                );
              })}
            </div>
            <aside className="bg-[var(--ivory-deep)] p-8 h-fit lg:sticky lg:top-32">
              <h2 className="font-display text-2xl mb-6">Order Summary</h2>
              <div className="flex justify-between text-sm mb-2">
                <span>{t.cart.subtotal}</span>
                <span>{formatPrice(cartSubtotal, currency)}</span>
              </div>
              <p className="text-xs text-[var(--grey)] mb-6">{t.cart.tax}</p>
              <button onClick={() => nav("/checkout")} className="btn-lux w-full bg-[var(--noir)] text-[var(--ivory)] py-4 text-[11px] tracking-[0.25em] uppercase hover:text-[var(--gold)]" data-testid="cart-checkout-btn">
                {t.cart.checkout}
              </button>
            </aside>
          </div>
        )}
      </div>
    </main>
  );
};

export default CartPage;
